let roomImage = null;
let rugImage = null;

let rugSizeKey = '5x7';

// Real rug sizes in feet (width x height/depth)
const rugSizes = {
  '3x5':  { w: 3,  h: 5  },
  '4x6':  { w: 4,  h: 6  },
  '5x7':  { w: 5,  h: 7  },
  '5x8':  { w: 5,  h: 8  },
  '6x9':  { w: 6,  h: 9  },
  '8x10': { w: 8,  h: 10 },
  '9x12': { w: 9,  h: 12 },
  '10x14':{ w: 10, h: 14 },
  '12x15':{ w: 12, h: 15 }
};

// Assumed room width in feet (used to convert ft -> px)
const ROOM_WIDTH_FT = 14;

let rugRotation = 0; // degrees
let rugPerspective = 0;

let rugX = 0.58;
let rugY = 0.84;

let showAfter = true;
let isDragging = false;
let isRotating = false;
let rotateStartAngle = 0;
let rugStartRotation = 0;

document.addEventListener('DOMContentLoaded', () => {

  const productContainer = document.getElementById('rugProducts');
  const canvas = document.getElementById('roomCanvas');
  const ctx = canvas.getContext('2d');
  const upload = document.getElementById('roomUpload');
  const rugSizeSelect = document.getElementById('rugSize');
  const rugPerspectiveSlider = document.getElementById('rugPerspective');
  const downloadBtn = document.getElementById('downloadRoom');
  const searchInput = document.getElementById('rugSearch');
  const toggleButtons = document.querySelectorAll('#beforeAfterToggle button');
  const rugControl = document.getElementById('rugControl');
  const canvasWrap = document.querySelector('.hrc-canvas-wrap');

  if (rugSizeSelect) {
    rugSizeKey = rugSizeSelect.value;
  }

  /* DEFAULT ROOM IMAGE */
  roomImage = new Image();
  roomImage.crossOrigin = "anonymous";
  roomImage.onload = function () {
    canvas.width = roomImage.width;
    canvas.height = roomImage.height;
    drawScene();
  };
  roomImage.src = 'https://cdn.shopify.com/s/files/1/0767/8305/9102/files/ChatGPT_Image_Jun_12_2026_04_22_30_PM.png?v=1781261608';

  // Get current rug dimensions in canvas pixels
  function getRugDimensions() {
    if (!rugImage) return { rugWidth: 0, rugHeight: 0 };

    const size = rugSizes[rugSizeKey] || rugSizes['5x7'];

    const pxPerFt = canvas.width / ROOM_WIDTH_FT;

    const rugWidth = size.w * pxPerFt;
    const rugHeight = size.h * pxPerFt;

    return { rugWidth, rugHeight };
  }

  function drawScene() {

    if (!roomImage) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(roomImage, 0, 0, canvas.width, canvas.height);

    if (!showAfter) {
      updateControlOverlay(null);
      return;
    }

    if (rugImage) {

      const { rugWidth, rugHeight } = getRugDimensions();

      const posX = canvas.width * rugX;
      const posY = canvas.height * rugY;

      ctx.save();

      ctx.translate(posX, posY);
      ctx.rotate(rugRotation * Math.PI / 180);

      // Floor par flat dikhne ke liye: strong vertical compression (depth)
      // + halka shear perspective slider se. Pehle ka (1,0,rugPerspective,0.82,0,0)
      // rug ko "khada/tilted" dikhata tha kyunki c-param (X-skew based on Y) galat tha.
      const depthScale = 0.55;                 // floor receding effect
      const skew = rugPerspective * 0.25;      // slider se halka horizontal shear
      ctx.transform(1, 0, skew, depthScale, 0, 0);

      ctx.shadowColor = 'rgba(0,0,0,.12)';
      ctx.shadowBlur = 10;
      ctx.shadowOffsetY = 5;
      ctx.globalAlpha = 0.98;

      ctx.drawImage(
        rugImage,
        -rugWidth / 2,
        -rugHeight / 2,
        rugWidth,
        rugHeight
      );

      ctx.globalAlpha = 1;
      ctx.restore();

      updateControlOverlay({ posX, posY, rugWidth, rugHeight });

    } else {
      updateControlOverlay(null);
    }
  }

  // Position the rotation ring/handles over the rug, scaled to displayed canvas size
  function updateControlOverlay(rugInfo) {

    if (!rugControl) return;

    if (!rugInfo) {
      rugControl.style.display = 'none';
      return;
    }

    rugControl.style.display = 'block';

    const rect = canvas.getBoundingClientRect();
    const wrapRect = canvasWrap.getBoundingClientRect();

    const scaleX = rect.width / canvas.width;
    const scaleY = rect.height / canvas.height;

    const dispX = rugInfo.posX * scaleX + (rect.left - wrapRect.left);
    const dispY = rugInfo.posY * scaleY + (rect.top - wrapRect.top);

    const dispW = rugInfo.rugWidth * scaleX;
    const dispH = rugInfo.rugHeight * scaleY;

    const ringSize = Math.max(dispW, dispH) * 1.15;

    const ring = rugControl.querySelector('.hrc-rotate-ring');
    ring.style.width = ringSize + 'px';
    ring.style.height = ringSize + 'px';
    ring.style.left = dispX + 'px';
    ring.style.top = dispY + 'px';

    const radius = ringSize / 2;
    const angleRad = rugRotation * Math.PI / 180;

    // top handle
    placeHandle('.hrc-handle-top', dispX, dispY, radius, angleRad - Math.PI / 2);
    // right handle
    placeHandle('.hrc-handle-right', dispX, dispY, radius, angleRad);
    // bottom handle
    placeHandle('.hrc-handle-bottom', dispX, dispY, radius, angleRad + Math.PI / 2);
  }

  function placeHandle(selector, cx, cy, radius, angle) {
    const handle = rugControl.querySelector(selector);
    const hx = cx + radius * Math.cos(angle);
    const hy = cy + radius * Math.sin(angle);
    handle.style.left = hx + 'px';
    handle.style.top = hy + 'px';
  }

  /* UPLOAD ROOM IMAGE */
  upload.addEventListener('change', function (e) {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = function (event) {
      roomImage = new Image();
      roomImage.onload = function () {
        canvas.width = roomImage.width;
        canvas.height = roomImage.height;
        drawScene();
      };
      roomImage.src = event.target.result;
    };
    reader.readAsDataURL(file);
  });

  /* SIZE SELECT */
  if (rugSizeSelect) {
    rugSizeSelect.addEventListener('change', () => {
      rugSizeKey = rugSizeSelect.value;
      drawScene();
    });
  }

  /* PERSPECTIVE */
  rugPerspectiveSlider.addEventListener('input', () => {
    rugPerspective = rugPerspectiveSlider.value / 100;
    drawScene();
  });

  /* BEFORE / AFTER TOGGLE */
  toggleButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      toggleButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      showAfter = btn.dataset.view === 'after';
      drawScene();
    });
  });

  /* DRAG TO MOVE RUG */
  canvas.addEventListener('mousedown', (e) => {
    if (!rugImage || !showAfter) return;
    isDragging = true;
  });

  canvas.addEventListener('mouseup', () => {
    isDragging = false;
  });

  canvas.addEventListener('mouseleave', () => {
    isDragging = false;
  });

  canvas.addEventListener('mousemove', e => {
    if (!isDragging) return;

    const rect = canvas.getBoundingClientRect();
    rugX = (e.clientX - rect.left) / rect.width;
    rugY = (e.clientY - rect.top) / rect.height;

    drawScene();
  });

  /* ROTATION VIA HANDLES */
  if (rugControl) {
    rugControl.querySelectorAll('[data-handle="rotate"]').forEach(handle => {
      handle.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!rugImage) return;

        isRotating = true;
        rugStartRotation = rugRotation;

        const wrapRect = canvasWrap.getBoundingClientRect();
        const ring = rugControl.querySelector('.hrc-rotate-ring');
        const ringRect = ring.getBoundingClientRect();

        const centerX = ringRect.left + ringRect.width / 2;
        const centerY = ringRect.top + ringRect.height / 2;

        rotateStartAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
        rotateStartAngle -= rugRotation * Math.PI / 180;
      });
    });
  }

  window.addEventListener('mousemove', (e) => {
    if (!isRotating || !rugImage) return;

    const ring = rugControl.querySelector('.hrc-rotate-ring');
    const ringRect = ring.getBoundingClientRect();

    const centerX = ringRect.left + ringRect.width / 2;
    const centerY = ringRect.top + ringRect.height / 2;

    const angle = Math.atan2(e.clientY - centerY, e.clientX - centerX);

    rugRotation = (angle - rotateStartAngle) * 180 / Math.PI;

    drawScene();
  });

  window.addEventListener('mouseup', () => {
    isRotating = false;
  });

  /* DOWNLOAD */
  downloadBtn.addEventListener('click', () => {
    const link = document.createElement('a');
    link.download = 'visualized-room.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  });

  /* PRODUCTS */
  let allProducts = [];

  fetch('/collections/shop-all-rugs/products.json?limit=250')
    .then(res => res.json())
    .then(data => {
      allProducts = data.products;
      renderProducts(allProducts);
    });

  function renderProducts(products) {

    productContainer.innerHTML = '';

    products.forEach(product => {

      let image = '';
      if (product.images && product.images.length) {
        image = product.images[0].src;
      }

      productContainer.innerHTML += `
        <div class="rug-card" data-image="${image}">
          <img src="${image}">
          <div class="rug-title">${product.title}</div>
        </div>
      `;
    });

    document.querySelectorAll('.rug-card').forEach(card => {
      card.addEventListener('click', () => {

        rugImage = new Image();
        rugImage.crossOrigin = 'anonymous';

        rugImage.onload = function () {
          rugRotation = 0;
          drawScene();
        };

        rugImage.src = card.dataset.image;
      });
    });
  }

  if (searchInput) {
    searchInput.addEventListener('keyup', () => {
      const term = searchInput.value.toLowerCase();
      const filtered = allProducts.filter(product =>
        product.title.toLowerCase().includes(term)
      );
      renderProducts(filtered);
    });
  }

  // Reposition overlay on resize
  window.addEventListener('resize', drawScene);

});
